import { Injectable } from '@angular/core';
import { System } from '../resources/system';
import { BlockchainsEnum } from '../enums/blockchains.enum';
import { Network } from '../resources/networks';

@Injectable({
    providedIn: 'root'
})
export class NetworkFilterHelper {
    private networksList: { [key: string]: Array<BlockchainsEnum> } = {
        t: [BlockchainsEnum.TRON],
        T: [BlockchainsEnum.TRON],
        '0x': [BlockchainsEnum.ETHEREUM, BlockchainsEnum.POLYGON, BlockchainsEnum.SOLANA, BlockchainsEnum.BNB],
        bitcoin: [BlockchainsEnum.BITCOIN]
    };

    public disableNetworks(address: string, system: System): Array<{ network: Network; disabled: boolean }> {
        const prefixMappings: Array<string> = Object.keys(this.networksList);
        const defaultNetwork: string = 'bitcoin';

        const prefix: string = prefixMappings.find((key) => address.startsWith(key)) || defaultNetwork;
        const networksToKeep: Array<BlockchainsEnum> = this.networksList[prefix];

        if (!system.relationships.networks || system.relationships.networks.data.length === 0) {
            return [];
        }

        return system.relationships.networks.data.map((network: Network) => ({
            network,
            disabled: address !== '' && !networksToKeep.includes(network.id as BlockchainsEnum)
        }));
    }

    public getNetworkByAddress(address: string, networksMapped: any): BlockchainsEnum {
        const prefixMappings: Array<string> = Object.keys(this.networksList);
        const defaultNetwork: string = 'bitcoin';

        const prefix: string = prefixMappings.find((key) => address.startsWith(key)) || defaultNetwork;
        const networksToKeep: Array<BlockchainsEnum> = this.networksList[prefix];

        let networkToReturn: BlockchainsEnum = BlockchainsEnum.BITCOIN;

        networksMapped.forEach((networkMapped: any) => {
            if (networksToKeep.includes(networkMapped.network.id)) {
                networkToReturn = networkMapped.network.id;
            }
        });

        return networkToReturn;
    }
}
